import { tz as tzFn } from '@date-fns/tz';
import type {
  Nullable,
  TimeRange,
  TimeZone,
  WorkingHour,
} from '@iheartjane/types';
import { timezone } from '@iheartjane/utils';
import { format } from 'date-fns';

export const timeRangeForDay = (
  weeklyHours: Nullable<WorkingHour[]>,
  tz: TimeZone,
  date: Date = new Date()
): Nullable<TimeRange> => {
  try {
    /** The weekday name at the *given* time zone, not the local zone  */
    const dayName = format(date, 'eeee', {
      in: tzFn(timezone(tz)),
    }).toLowerCase();
    const dayHours = weeklyHours?.find((h) => h.day === dayName);

    if (dayHours?.period.from && dayHours.period.to) {
      /** returning a new object to accommodate typescript's limited type-narrowing */
      return {
        from: dayHours.period.from,
        to: dayHours.period.to,
      };
    } else {
      return null;
    }
  } catch {
    return null;
  }
};
